export default __webpack_public_path__ + "static/navLinks-d07ccb3d9288f8febd4c7a920d4b467c.png";